import ApiUser from 'types/api/User';

import Model from 'models/Model';

export enum Roles {
    Admin = 'admin',
    Physio = 'physio',
    Patient = 'patient',
    Owner = 'owner',
}

export default class User implements Model {
    id: string;
    firstName: string;
    lasName: string;
    email: string;
    phone: string;
    role: Roles;

    constructor(data: ApiUser) {
        this.id = data.id;
        this.firstName = data.firstName;
        this.lasName = data.lasName;
        this.email = data.email;
        this.phone = data.phone;
        this.role = data.role;
    }
}